import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	title: {
		id: 'eoc.heartbeats.empty-state.title.no-translate',
		defaultMessage: 'Add your first heartbeat',
		description: 'Title of the empty state.',
	},
	description: {
		id: 'eoc.heartbeats.empty-state.description.no-translate',
		defaultMessage:
			'Heartbeats maintain the functionality of your systems by sending regular pings and generating alerts when unresponsive. <linkReadMore>Read more about heartbeats</linkReadMore>',
		description: 'Description of the empty state',
	},
	primaryActionButton: {
		id: 'eoc.heartbeats.empty-state.primary-action.no-translate',
		defaultMessage: 'Create heartbeat',
		description: 'Text of primary empty state button used to create heartbeat.',
	},
	secondaryActionButton: {
		id: 'eoc.heartbeats.empty-state.secondary-action.no-translate',
		defaultMessage: 'Turn on auto-heartbeats',
		description: 'Text of secondary empty state button used to turn on auto heartbeat creation.',
	},
});

export default messages;
